import { createContext } from 'react';
import type { SignalIncident } from 'src/graphql/entities/signal-incident/signal-incident.types';

export interface SignalIncidentContextValue {
  updatingId: string | null;
  resolve: (incident: SignalIncident) => Promise<void>;
  incidents: SignalIncident[];
  isLoading: boolean;
  error: Error | undefined;
}

export const SignalIncidentContext = createContext<SignalIncidentContextValue | null>(null);
